import React from 'react';
import ElencoNoteAttive from './ElencoNoteAttive'

function ElencoNoteAttiveLavoratore({ note, lavoratori, sedi }) {
    if (!note || note.length === 0) {
        return <p className="text-center" id="no-note">Non ci sono note attive da visualizzare.</p>;
    }

    return (
        <div className="mt-3">
            <ElencoNoteAttive note={note} lavoratori={lavoratori} sedi={sedi} />
        </div>
    );
}

export default ElencoNoteAttiveLavoratore;
